"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "d-flex flex-gap" };
const _hoisted_2 = { class: "form-radio form-inline" };
const _hoisted_3 = ["checked"];
const _hoisted_4 = { class: "form-radio form-inline" };
const _hoisted_5 = ["checked", "disabled"];
const _hoisted_6 = {
    key: 0,
    class: "relative"
};
const _hoisted_7 = { class: "form-group d-flex flex-gap flex-align-center flex-justify-between flex-wrap" };
const _hoisted_8 = { class: "d-flex flex-align-center flex-wrap" };
const _hoisted_9 = { class: "d-flex" };
const _hoisted_10 = { class: "form-radio form-inline ml-2" };
const _hoisted_11 = { class: "form-radio form-inline" };
const _hoisted_12 = {
    key: 0,
    class: "d-flex"
};
const _hoisted_13 = { class: "form-group d-flex flex-gap mt-2 flex-align-center flex-wrap" };
const _hoisted_14 = { class: "d-flex flex-wrap ml-2" };
const _hoisted_15 = { class: "form-radio form-inline" };
const _hoisted_16 = ["checked"];
const _hoisted_17 = { class: "form-radio form-inline" };
const _hoisted_18 = ["checked"];
const _hoisted_19 = {
    class: "oplus-form-checkbox m-1",
    for: "evenly"
};
const _hoisted_20 = ["checked"];
const _hoisted_21 = {
    class: "oplus-form-checkbox m-1",
    for: "work-evenly"
};
const _hoisted_22 = ["checked"];
const roles_1 = require("../../js/roles");
const RoleRequiredCalendar_vue_1 = __importDefault(require("../../roleRequiredCalendar/RoleRequiredCalendar.vue"));
const RoleRequiredByDay_vue_1 = __importDefault(require("./RoleRequiredByDay.vue"));
const RoleRequiredByStaff_vue_1 = __importDefault(require("./RoleRequiredByStaff.vue"));
const RoleRequiredWeekly_vue_1 = __importDefault(require("./RoleRequiredWeekly.vue"));
const vue_3 = require("vue");
// inject RoleView
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleRequiredWrapper',
    props: {
        hasAutoPerm: Boolean,
    },
    setup(__props) {
        const role = (0, vue_3.inject)("roleView");
        const roleRequiredType = (0, vue_3.computed)(() => {
            return role?.value.type || 0;
        });
        const roleDaysReqSettings = (0, vue_3.ref)(0);
        const employeePriorityType = (0, vue_3.ref)(role?.value.employeePriority ?? 1);
        const evenly = (0, vue_3.ref)(Boolean(role?.value.evenly));
        const workEvenly = (0, vue_3.ref)(Boolean(role?.value.workEvenly));
        async function handleEmpPriorityChange(value) {
            employeePriorityType.value = value;
            if (!role) {
                return;
            }
            await (0, roles_1.handleRoleEmpPriorityUpdate)(role.value.id, value);
        }
        async function handleEvenlyChange(e) {
            if (!role) {
                return;
            }
            const target = e.target;
            const value = target.checked;
            await (0, roles_1.handleRoleEvenlyUpdate)(role?.value.id, value);
        }
        async function handleWorkEvenlyChange(e) {
            if (!role) {
                return;
            }
            const target = e.target;
            const value = target.checked;
            await (0, roles_1.handleRoleWorkEvenlyUpdate)(role.value.id, value);
        }
        async function handleTypeChange(type) {
            if (!role) {
                return;
            }
            await (0, roles_1.handleRoleTypeUpdate)(role.value.id, type);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createCommentVNode)(" Radio for now, in the future it will be change to checkbox "),
                    (0, vue_2.createElementVNode)("label", _hoisted_2, [
                        (0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            name: "role-type-settings",
                            value: 0,
                            onChange: _cache[0] || (_cache[0] = ($event) => (handleTypeChange(0))),
                            checked: (0, vue_2.unref)(role)?.type === 0
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3),
                        _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                        _cache[9] || (_cache[9] = (0, vue_2.createTextVNode)(" 曜日別 ", -1 /* CACHED */))
                    ]),
                    (0, vue_2.createElementVNode)("label", _hoisted_4, [
                        (0, vue_2.createElementVNode)("input", {
                            type: "radio",
                            name: "role-type-settings",
                            value: 1,
                            onChange: _cache[1] || (_cache[1] = ($event) => (handleTypeChange(1))),
                            checked: (0, vue_2.unref)(role)?.type === 1,
                            disabled: !__props.hasAutoPerm
                        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
                        _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                        _cache[11] || (_cache[11] = (0, vue_2.createTextVNode)(" スタッフごと ", -1 /* CACHED */))
                    ])
                ]),
                _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("div", { class: "role-required-divider" }, null, -1 /* CACHED */)),
                (roleRequiredType.value === 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, [
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                _cache[16] || (_cache[16] = (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "必要人数", -1 /* CACHED */)),
                                (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "radio",
                                            name: "role-days-settings",
                                            value: 0,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((roleDaysReqSettings).value = $event))
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roleDaysReqSettings.value]
                                        ]),
                                        _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                        _cache[13] || (_cache[13] = (0, vue_2.createTextVNode)(" 設定 ", -1 /* CACHED */))
                                    ]),
                                    (0, vue_2.createElementVNode)("label", _hoisted_11, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            type: "radio",
                                            name: "role-days-settings",
                                            value: 1,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((roleDaysReqSettings).value = $event))
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelRadio, roleDaysReqSettings.value]
                                        ]),
                                        _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                        _cache[15] || (_cache[15] = (0, vue_2.createTextVNode)(" 上書き ", -1 /* CACHED */))
                                    ])
                                ])
                            ]),
                            (roleDaysReqSettings.value === 1)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, [
                                    (0, vue_2.createCommentVNode)(" ToDO: refactor these buttons as well "),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-secondary",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.showDashModal(true, 'role-csv')))
                                    }, "インポート"),
                                    (0, vue_2.createElementVNode)("button", {
                                        class: "btn btn-secondary",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.outputRoleCSV()))
                                    }, "ダウンロード")
                                ]))
                                : (0, vue_2.createCommentVNode)("v-if", true)
                        ]),
                        (0, vue_2.createCommentVNode)(" Settings type 0 (設定)"),
                        (roleDaysReqSettings.value === 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(RoleRequiredWeekly_vue_1.default, { key: 0 }))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                                (0, vue_2.createCommentVNode)(" Settings type 1 (上書き) "),
                                (0, vue_2.createVNode)(RoleRequiredCalendar_vue_1.default)
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                            _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "配置スタッフ", -1 /* CACHED */)),
                            (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                (0, vue_2.createElementVNode)("label", _hoisted_15, [
                                    (0, vue_2.createElementVNode)("input", {
                                        type: "radio",
                                        name: "employee-priority-settings",
                                        checked: employeePriorityType.value === 0,
                                        onChange: _cache[6] || (_cache[6] = ($event) => (handleEmpPriorityChange(0)))
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_16),
                                    _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                    _cache[18] || (_cache[18] = (0, vue_2.createTextVNode)(" 上優先 ", -1 /* CACHED */))
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_17, [
                                    (0, vue_2.createElementVNode)("input", {
                                        type: "radio",
                                        name: "employee-priority-settings",
                                        checked: employeePriorityType.value === 1,
                                        onChange: _cache[7] || (_cache[7] = ($event) => (handleEmpPriorityChange(1)))
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_18),
                                    _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("i", { class: "form-icon" }, null, -1 /* CACHED */)),
                                    _cache[20] || (_cache[20] = (0, vue_2.createTextVNode)(" ランダム ", -1 /* CACHED */))
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_19, [
                                    _cache[21] || (_cache[21] = (0, vue_2.createTextVNode)(" 均等に ", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("input", {
                                        id: "evenly",
                                        onChange: handleEvenlyChange,
                                        checked: evenly.value,
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_20)
                                ]),
                                (0, vue_2.createElementVNode)("label", _hoisted_21, [
                                    _cache[22] || (_cache[22] = (0, vue_2.createTextVNode)(" 出勤数順 ", -1 /* CACHED */)),
                                    (0, vue_2.createElementVNode)("input", {
                                        id: "work-evenly",
                                        onChange: handleWorkEvenlyChange,
                                        checked: workEvenly.value,
                                        type: "checkbox"
                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_22)
                                ])
                            ])
                        ]),
                        (0, vue_2.createCommentVNode)(" Staff list "),
                        (0, vue_2.createVNode)(RoleRequiredByDay_vue_1.default)
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                        (0, vue_2.createCommentVNode)(" Role Type 1 "),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createCommentVNode)(" Staff list "),
                            (0, vue_2.createElementVNode)("div", null, [
                                _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("span", { class: "h5 mr-2" }, "配置スタッフ", -1 /* CACHED */)),
                                (0, vue_2.createVNode)(RoleRequiredByStaff_vue_1.default)
                            ])
                        ])
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
